import React from 'react';
import _ from 'underscore';

import { SpaceInfo, SpaceItemForNonEntitySpace } from '../../state/SpaceInfo';

import { ConnectedSpaceInfoProvider } from '../RouterHelpers/SpaceInfoProvider';
import { Host } from '../../../serverStatus/types/Host';
import { ServerInfoService } from '../../../serverStatus/services/ServerInfoService';
import { ServerStatus } from '../../../serverStatus/components/ServerStatus';

export interface ServerStatusSpaceProvideState {
  hosts: Host[];
}

const ServerStatusSpaceInfo: SpaceInfo = {
  spaceType: 'serverstatus',
  subspaceName: undefined,
  item: SpaceItemForNonEntitySpace
};

const PollMS = 60000;

export class ServerStatusSpaceProvider extends React.PureComponent<{}, ServerStatusSpaceProvideState> {
  private timeoutId: number;

  public constructor(props: {}) {
    super(props);
    this.state = {
      hosts: []
    };
  }

  public componentDidMount() {
    this.setHosts();
    //Fetch updates every 60 seconds
    this.timeoutId = window.setInterval(this.setHosts, PollMS);
  }

  public componentWillUnmount() {
    this.timeoutId ? window.clearTimeout(this.timeoutId) : null;
  }

  public render() {
    return (
      <ConnectedSpaceInfoProvider spaceInfo={ServerStatusSpaceInfo}>
          <ServerStatus hosts={this.state.hosts} triggerRefresh={this.triggerRefresh}/>
      </ConnectedSpaceInfoProvider>
    );
  }

  private setHosts = async (): Promise<void> => {
    const hosts = await ServerInfoService.fetch();
    this.setState({ hosts: hosts });
  }

  private triggerRefresh = (): Promise<void> => {
    this.setState({hosts: []}); // Workaround to show spinner if refresh is manually triggered
    this.timeoutId && window.clearTimeout(this.timeoutId); //clear the existing timeout
    this.timeoutId = window.setInterval(this.setHosts, PollMS); //Set new interval from the current time
    return this.setHosts();
  }

}
